import { SignUp } from '@clerk/react';

/**
 * Hosted sign-up page. Mounted under /sign-up/* so Clerk can do its own
 * sub-routing (email verification, ticket consumption, etc).
 *
 * The critical job this page does is process organization-invitation
 * tickets. When a recipient clicks the email link from /admin/staff →
 * Invite, Clerk redirects them here with `__clerk_ticket` and
 * `__clerk_status=sign_up` query params. The <SignUp /> component reads
 * those params automatically and ties the new account to the invitation,
 * so the user is added to the right org on completion. After sign-up
 * the user lands on /staff (via forceRedirectUrl), where the staff
 * dashboard takes over.
 */
export default function SignUpPage() {
  return (
    <div className="auth-page">
      <SignUp
        routing="path"
        path="/sign-up"
        signInUrl="/sign-in"
        forceRedirectUrl="/staff"
      />
    </div>
  );
}
